"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuelEditor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_select_1 = __importDefault(require("react-select"));
const common_styled_components_1 = require("../../../common-styled-components");
const optionUtil_1 = require("../../../../util/compliance/optionUtil");
const lodash_1 = require("lodash");
const react_1 = require("react");
const NumberInput_1 = require("../../../generic/NumberInput");
const emptyFuelOption = (0, optionUtil_1.getEmptyOption)("fuel");
const FuelEditor = ({ metadata, updateFuelAmount, index, initialValue, remove, }) => {
    const [fuelAmount, setFuelAmount] = (0, react_1.useState)(initialValue ?? {
        fuel_type_id: 13,
        amount_t: 0,
    });
    (0, react_1.useEffect)(() => {
        updateFuelAmount(index, fuelAmount);
    }, [fuelAmount]);
    const fuelOptions = [emptyFuelOption].concat(metadata
        ? (0, lodash_1.values)(metadata.fuels).map((fuel) => ({
            label: fuel.description,
            value: fuel.fuel,
        }))
        : []);
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SeparatedRow, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SelectorLabel, { children: ["Fuel ", index + 1] }), remove && ((0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { type: "button", onClick: () => remove(index), children: "- Remove" }))] }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: fuelOptions, onChange: (newValue) => {
                        const selectedValue = newValue?.value ?? null;
                        if (selectedValue == null) {
                            return;
                        }
                        setFuelAmount((prev) => ({
                            ...prev,
                            fuel_type_id: selectedValue,
                        }));
                    }, value: fuelOptions.find((o) => fuelAmount.fuel_type_id === o.value) ??
                        emptyFuelOption, isOptionSelected: (option) => option.value === fuelAmount.fuel_type_id }), (0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Amount (t)" }), (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { value: fuelAmount.amount_t, onChange: (value) => setFuelAmount((prev) => ({
                        ...prev,
                        amount_t: value,
                    })), isFloat: true })] }) }));
};
exports.FuelEditor = FuelEditor;
